import { languageConstants } from "constants/languageConstants";

export const getLanguageFromPath = (pathname) => {
  const match = pathname.match(/^\/([a-z]{2})(\/|$)/);
  const lang = match ? match[1] : "pl";
  return languageConstants.includes(lang) ? lang : "pl";
};

export const getInitialLanguage = () => {}
